
const { SELECTOR_PRODUCT_TILE, SELECTOR_PRODUCT_TILE_CONTAINER, SELECTOR_VIEW_FULL_DETAILS } = require('./productTileConstants.js');

const $body = $('body');

const handleTileEvents = () => {
    // Adding to history page URL on wich the current product tile is available
    // for case when user from 6 page (for example) scrolled up to 2, open PDP and then press Browser Back Button
    $body.on('click', SELECTOR_PRODUCT_TILE, e => {
        const el = e.currentTarget;
        const container = el.closest(SELECTOR_PRODUCT_TILE_CONTAINER);
        const { pageNumber = null } = container?.dataset || {};

        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('start') && urlParams.has('sz') && pageNumber !== null) {
            const sz = parseInt(urlParams.get('sz'), 10);
            let newStart = parseInt(pageNumber, 10) * sz;
            let parsedUrl = new URL(window.location.href);
            parsedUrl.searchParams.set('start', newStart);
            window.history.pushState({}, "", parsedUrl);
        }
    });
    // add Stylitics Complete Look product click tracking
    $body.on('click', SELECTOR_VIEW_FULL_DETAILS, e => {
        const el = e.currentTarget;
        const styliticsContainer = el.closest('.js-stylitics-product-data');
        const styliticsMainContainer = styliticsContainer.closest('.js-complete-look-container');
        if (!styliticsContainer || !styliticsMainContainer) return;
        const { styliticsProductId, styliticsProductItemid, styliticsProductIndex } = styliticsContainer.dataset;
        const { styliticsOutfitid } = styliticsMainContainer.dataset;
        styliticsMainContainer.dispatchEvent(
            new CustomEvent('stylitics:completeLook:trackItemClick', {
                detail: {
                    pid: styliticsProductId,
                    itemId: styliticsProductItemid,
                    index: styliticsProductIndex,
                    placement: 'widget',
                    outfitId: styliticsOutfitid
                },
                bubbles: true
            })
        );
    });
    // Stylitics Complete Look product image click disable
    $body.on('click', '.js-stylitics-product-data .js-carousel-wrapper .js-product-tile-link', e => {
        e.preventDefault();
        return;
    });
};

export default handleTileEvents;
